<template>
    <div class="checkout">
        <Checkout></Checkout>

        <div class="container-fluid toprow">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12">
                        <Alerts />
                    </div>
                </div>
            </div>
        </div>

        <router-view v-if="isLoggedIn"></router-view>

        <div class="container" v-if="!isLoggedIn">
            <div class="row">
                <div class="col-xs-12 toprow">
                    Please log in to proceed with the checkout.
                    <br><br>
                    <a class="btn btn-sm btn-primary" href="/login">Login to continue</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import Alerts from '../../shared/components/Alerts.vue'
import Checkout from '../components/Checkout.vue'
import useCart from  '../composables/useCart'

export default {
    name: 'CheckoutView',
    components: {
        Alerts,
        Checkout
    },
    setup () {
        const { isLoggedIn } = useCart();

        return {
            isLoggedIn
        }
    }
}
</script>
